/**
 * leavePage.ts — the one full-page navigation the connect flow makes: to the
 * service's own consent page (no popup). Its own module so tests can watch
 * it; jsdom cannot spy on window.location.assign.
 */
export function leavePageFor(url: string): void {
  window.location.assign(url);
}
